import { MetricsContextProvider } from 'modules/productAnalytics/context';
import { MESSAGING_INSIGHTS } from 'modules/messagingInsights/constants';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { SENDS_GRID_AREA } from '../CampaignsHealthDashboard.constants';
import { CampaignsHealthMetricsContents } from './CampaignsHealthMetricsContents';
import { DashboardCard } from '../../Dashboard.styled';

const StyledDashboardCard = styled(DashboardCard)`
  && {
    padding: ${spacing.plusHalf};
    padding-bottom: 0;
  }
`;

const AnalyticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  grid-area: ${SENDS_GRID_AREA};
  height: 100%;
`;

export const CAMPAIGNS_HEALTH_METRICS_TEST_ID = 'campaigns-health-metrics';

export const CampaignsHealthMetrics = () => {
  return (
    <StyledDashboardCard>
      <MetricsContextProvider page={MESSAGING_INSIGHTS}>
        <AnalyticsContainer data-test={CAMPAIGNS_HEALTH_METRICS_TEST_ID}>
          <CampaignsHealthMetricsContents />
        </AnalyticsContainer>
      </MetricsContextProvider>
    </StyledDashboardCard>
  );
};
